import React from 'react';
import { motion } from 'framer-motion';

export const sectionFadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.08 },
  transition: { duration: 0.5, ease: 'easeOut' },
};

export const SectionShell = ({ id, eyebrow, title, description, children, className = '' }) => {
  return (
    <motion.section id={id} className={`mx-auto w-full max-w-6xl px-4 py-10 md:py-14 ${className}`} {...sectionFadeUp}>
      {eyebrow ? (
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-ga-primary">{eyebrow}</p>
      ) : null}
      {title ? <h2 className="text-2xl font-bold leading-tight text-ga-text-primary md:text-4xl">{title}</h2> : null}
      {description ? <p className="mt-4 max-w-3xl text-sm text-ga-text-muted md:text-base">{description}</p> : null}
      <div className="mt-8">{children}</div>
    </motion.section>
  );
};

export const GlowButton = ({ as = 'button', children, className = '', variant = 'primary', ...props }) => {
  const Comp = as;
  const base =
    'inline-flex items-center justify-center rounded-xl px-5 py-3 text-sm font-semibold transition-all duration-300 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0 disabled:hover:shadow-none';
  const variants = {
    primary:
      'bg-ga-green text-slate-950 shadow-[0_0_0_rgba(0,200,83,0.5)] hover:-translate-y-0.5 hover:shadow-[0_0_30px_rgba(0,200,83,0.45)]',
    ghost:
      'border border-ga-border-subtle bg-ga-bg-surface/10 text-ga-text-primary hover:-translate-y-0.5 hover:border-ga-primary hover:text-ga-primary hover:bg-ga-primary-soft',
  };

  return (
    <Comp className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </Comp>
  );
};

export const GlassCard = ({ children, className = '' }) => {
  return <div className={`glass-card rounded-2xl p-5 md:p-6 ${className}`}>{children}</div>;
};
